import { css } from '@uifabric/utilities/lib/css';
import * as React from 'react';

export interface ITdProps {
    className?: string;
    colSpan?: number;
    style?: React.CSSProperties;
    children: React.ReactNode;
    isSticky?: boolean;
    width?: number;
}

export interface ITdHandle {
    updatePosition: (left: number) => void;
}

export const Td = React.forwardRef<ITdHandle, ITdProps>(({
    className,
    colSpan,
    style,
    isSticky,
    children,
    width
}, forwardedRef) => {
    const tdRef = React.useRef<HTMLTableCellElement | null>(null);

    React.useImperativeHandle(forwardedRef, () => ({
        updatePosition: (left: number) => {
            if (tdRef.current) {
                tdRef.current.style.left = `${left}px`;
            }
        }
    }), []);

    return (
        <td
            ref={tdRef}
            className={css(isSticky && 'sticky-column', className)}
            colSpan={colSpan}
            style={{ ...style, minWidth: width, maxWidth: width }}
        >
            {children}
        </td>
    );
});

export default Td;